<template>
  <div class="pagination">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="paginationItem.pageSize"
      layout="prev, pager, next, jumper"
      :total="paginationItem.pageTotal">
    </el-pagination>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Pagination',
  props: {
    paginationItem: {
      type: Object,
      default: ()=> {
        return {
          page_size: 10,
          pageTotal: 10,
          page_number: 1,
        }
      }
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  components: {

  },
  computed: {

  },
  async mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$emit('changePage', val)
    }
  }
}
</script>
<style lang="scss" scoped>

.pagination{
  padding: 8px 20px 20px;
}

</style>